import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormInfo from '../../components/forms/FormInfo';
import { localizations } from '../../localization/localization';
import { Control, Form, Field, Fieldset, ModelState, Errors } from 'react-redux-form';
import { renderDateTimeEdit, renderCheckbox, renderNewTextFieldUpperCase, renderNumberField, renderRadioButton, renderMultilineTextField, renderErrorInfoText, renderNewTextField } from '../../common/forms/FieldCreators';
import { UnitModel, UnitType, AddUnitModel, UnitProperties } from '../../units/UnitModels';
import nameof from '../../utils/nameof';
import { CitySuggestionDropDown } from '../../components/forms/CitySuggestionDropDown';
import FormItem from '../../components/forms/FormItem';
import { connect } from 'react-redux';
import DailyControls from '../../components/recurrence/DailyControls';
import WeeklyControls from '../../components/recurrence/WeeklyControls';
import MonthlyControls from '../../components/recurrence/MonthlyControls';
import DurationControls from '../../components/recurrence/DurationControls';
import { RecurrenceModel, RecurrenceType, weekdaySelected } from '../../common/models/Recurrence';
import { EditMode, FilterSettingsModel, LocationNameModel, FilterInfo, FilterMode, Reporter, FilterTarget } from '../../common/models/CommonModels';
import { SettingsProperties } from '../models/SettingsModels';
import * as moment from "moment";
import { CancellablePromise, makeCancellable } from '../../utils/makeCancellable';
import * as locationApi from "../../api/locationsApi";

const styles = (theme: Theme) => ({
    root: {
        display: 'flex',
    },
    checkBox: {
        marginLeft: 0
    }
});

interface AddNewFilterSettingFormState {
    selectedType: UnitType,
    allCities: LocationNameModel[],
    fromCityLocations: LocationNameModel[],
    toCityLocations: LocationNameModel[],
    selectedReporters: Reporter[]
}

interface AddNewFilterSettingFormProps {
    onCancel: () => void,
    onSubmit: (values: FilterSettingsModel) => void,
    updateDepartureCities: (cities: string[]) => void,
    updateDestinationCities: (cities: string[]) => void,
    updateReporters: (reporters: string[]) => void,
    isOpen: boolean
    formControl?: JSX.Element[] | JSX.Element;
    isEditMode: boolean;
}


interface FilterPanelProps {
    filterValues: {
        reporters: Reporter[]
    },
    editedItem: FilterSettingsModel | undefined
}

type FilterPanelState = FilterInfo;


type FormProps = WithStyles<"root" | "checkBox"> & EditMode

class AddNewFilterSettingForm extends React.Component<FilterPanelProps & AddNewFilterSettingFormProps & FormProps, {} & AddNewFilterSettingFormState & FilterPanelState>{
    private allCitiesPromise: CancellablePromise<LocationNameModel[] | never[]> | null = null;

    constructor(props: any) {
        super(props);

        const start = moment().startOf("day");

        const stateFilters = {
            filterMode: FilterMode.All,
            fromDate: start,
            toDate: start.clone().add(7, "days"),
            properties: [],
            reporter: [],
            selectedReporters: [],
            reportNumberSearch: props.initialValues && props.initialValues.reportNumberSearch || "",
            error: "",
            selectedType: UnitType.Trailer,
            fromCities: this.props.editedItem === undefined ? [] : (this.props.editedItem as FilterSettingsModel).departureCityIds,
            toCities: this.props.editedItem === undefined ? [] : (this.props.editedItem as FilterSettingsModel).destinationCityIds,
            allCities: [],
            fromCityLocations: [],
            toCityLocations: [],
        };
        
        this.state = stateFilters;

        this.handleToCityChange = this.handleToCityChange.bind(this);
        this.handleFromCityChange = this.handleFromCityChange.bind(this);
        this.handleReporterChange = this.handleReporterChange.bind(this);
    }

    public componentDidMount() {
        this.allCitiesPromise = makeCancellable<LocationNameModel[] | never[]>(locationApi.getLocationNames());
        this.allCitiesPromise
          .promise
          .then(data => {
            this.setState({ 
                allCities: data,
                fromCityLocations: data.filter(city => this.state.fromCities.includes(city.id)),
                toCityLocations: data.filter(city => this.state.toCities.includes(city.id))
            });
          })
          .catch((reason) => console.log('Fetching failed:', reason));

        const fromCityIds: string[] = this.props.editedItem === undefined ? [] : (this.props.editedItem as FilterSettingsModel).departureCityIds;
        const toCityIds: string[] = this.props.editedItem === undefined ? [] : (this.props.editedItem as FilterSettingsModel).destinationCityIds;
        const stateFilters = {
            fromCities: fromCityIds,
            toCities: toCityIds,
            reporter: [],
            error: ""
        };

        this.setState(stateFilters);
      }
    

    public componentWillUnmount() {
        if (this.allCitiesPromise != null) {
            this.allCitiesPromise.cancel();
        }
    }

    
    public render() {
        const { classes, isOpen } = this.props;
        const { reporters } = this.props.filterValues;
        const { allCities } = this.state;

        return (
            <Dialog open={isOpen}>
                <Form hideNativeErrors model="newFilterSetting" onSubmit={this.props.onSubmit} validators={{
                    '': {
                        hasName: (vals) => {
                            return vals.name && vals.name.length > 0;
                        }
                    },
                }}>
                <DialogTitle style={{ textAlign: "center" }}>
                    <Typography variant="h4" paragraph>
                        {!this.props.isEditMode ? localizations.actions.save : null}
                        {this.props.isEditMode ? localizations.actions.edit : null}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid item>
                        <Grid container direction="column" alignItems="center">
                            <FormInfo infoText={localizations.settings.fillInFilterSettingInformation} />
                                <DialogActions>
                                    <Grid item>
                                        <Grid container justify="center" spacing={4}>
                                            <FormItem>
                                                <Control.text
                                                    model={`.${nameof<FilterSettingsModel>("name")}`}
                                                    component={renderNewTextField}
                                                    label={localizations.common.name}
                                                    placeholder={localizations.filterSettings.giveName}
                                                />
                                            </FormItem>
                                            <Errors
                                                model="newFilterSetting"
                                                show={{ touched: true, focus: false }}
                                                messages={{ hasName: localizations.validation.required  }}
                                                wrapper={renderErrorInfoText}
                                            />
                                            {/* <FormItem>
                                                <FormControl>
                                                    <Typography align="left" variant="body2">{localizations.common.filterTarget}</Typography>
                                                    <Field model={`.${nameof<FilterSettingsModel>("targetType")}`} dynamic={false}>
                                                        <FormControlLabel
                                                            control={
                                                                <Control.radio
                                                                    model={`.${nameof<FilterSettingsModel>("targetType")}`}
                                                                    component={renderRadioButton}
                                                                    value={"Cargo"}
                                                                />
                                                            }
                                                            label={localizations.filterTargetType[FilterTarget.Cargo]}
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <Control.radio
                                                                    model={`.${nameof<FilterSettingsModel>("targetType")}`}
                                                                    component={renderRadioButton}
                                                                    value={"Truck"}
                                                                />
                                                            }
                                                            label={localizations.filterTargetType[FilterTarget.Truck]}
                                                        />
                                                    </Field>
                                                </FormControl>
                                            </FormItem> */}
                                            <FormItem>
                                                <FormItem>
                                                    <Control.text
                                                        model={`.${nameof<FilterSettingsModel>("generalSearchField")}`}
                                                        component={renderNewTextField}
                                                        label={localizations.common.generalSearchField}
                                                    />
                                                </FormItem>
                                                {/* <FormItem>
                                                    <Control
                                                        style={{ width: "100%" }}
                                                        model={`.${nameof<FilterSettingsModel>("validFrom")}`}
                                                        component={renderDateTimeEdit}
                                                        required
                                                        label={localizations.filterSettings.activeFrom}
                                                    />
                                                </FormItem>
                                                <FormItem>
                                                    <Control
                                                        style={{ width: "100%" }}
                                                        model={`.${nameof<FilterSettingsModel>("validTo")}`}
                                                        component={renderDateTimeEdit}
                                                        required
                                                        label={localizations.filterSettings.activeTo}
                                                        />
                                                </FormItem>
                                                <Errors
                                                    model="newUnit"
                                                    show={{ touched: true, focus: false }}
                                                    messages={{ readyTimeIsBeforeDeliveryTime: localizations.validation.endTimeAfterStartTime }}
                                                    wrapper={renderErrorInfoText}
                                                /> */}
                                            </FormItem>
                                            <FormItem>
                                                <FormControl style={{ width: "100%", minWidth: "100" }}>
                                                    <Autocomplete
                                                        id="fromCity"
                                                        multiple
                                                        size="small"
                                                        options={allCities}
                                                        getOptionLabel={(option) => option.name}
                                                        limitTags={3}
                                                        renderInput={(params) => (
                                                            <TextField {...params} InputLabelProps={{ shrink: true }} variant="standard" label={localizations.common.pointOfDeparture} placeholder="" />
                                                        )}
                                                        value={this.state.fromCityLocations}
                                                        onChange={this.handleFromCityChange} />
                                                </FormControl>
                                            </FormItem>
                                            <FormItem>
                                                <FormControl style={{ width: "100%", minWidth: "100" }}>
                                                    <Autocomplete
                                                        id="toCity"
                                                        multiple
                                                        size="small"
                                                        options={allCities}
                                                        getOptionLabel={(option) => option.name}
                                                        limitTags={3}
                                                        renderInput={(params) => (
                                                            <TextField {...params} InputLabelProps={{ shrink: true }} variant="standard" label={localizations.common.pointOfArrival} placeholder="" />
                                                        )}
                                                        value={this.state.toCityLocations}
                                                        onChange={this.handleToCityChange} />
                                                </FormControl>
                                            </FormItem>
                                            <FormItem>
                                                <FormControl style={{ width: "100%", minWidth: "100" }}>
                                                    <Autocomplete
                                                        id="reportedBy"
                                                        multiple
                                                        size="small"
                                                        options={reporters}
                                                        getOptionLabel={(option) => option.name}
                                                        limitTags={3}
                                                        renderInput={(params) => (
                                                            <TextField {...params} InputLabelProps={{ shrink: true }} variant="standard" label={localizations.common.reporter} placeholder="" />
                                                        )}
                                                        value={this.state.selectedReporters}
                                                        onChange={this.handleReporterChange} />
                                                </FormControl>
                                            </FormItem>
                                            <FormItem>
                                                <Typography align="left" variant="body2">{localizations.common.properties}</Typography>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("adr")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.adr}
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("explosive")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.explosive}
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("thermal")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.thermal}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("tank")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.tank}
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("glass")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.glass}
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("mega")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.mega}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("pieceGoods")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.pieceGoods}
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("bulkGoods")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.bulkGoods}
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("trailer")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.trailer}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("containerOver20")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.containerOver20}
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormControlLabel
                                                                    className={classes.checkBox}
                                                                    control={
                                                                        <Control.checkbox
                                                                            model={`.${nameof<FilterSettingsModel>("properties")}.${nameof<SettingsProperties>("container20")}`}
                                                                            component={renderCheckbox}
                                                                        />
                                                                    }
                                                                    label={localizations.units.properties.container20}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </FormItem>
                                            <Grid item>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.props.onCancel}
                                                >
                                                    {localizations.actions.cancel}
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="secondary"
                                                >
                                                    {localizations.actions.save}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </DialogActions>
                        </Grid>
                    </Grid>
                </DialogContent>
                </Form>
            </Dialog>
        );
    }

    // Send filter state after submit.
    private handleReporterChange(event: any, value: Reporter[]) {
        const reporter = value.map(r => r.id);

        this.setState({
            reporter,
            selectedReporters: value
        });
        this.props.updateReporters(reporter);
    }

    private handleToCityChange(event: any, value: LocationNameModel[]) {
        const toCities = value.map(city => city.id);

        this.setState({
            toCities,
            toCityLocations: value,
        });
        this.props.updateDestinationCities(toCities);
    }

    private handleFromCityChange(event: any, value: LocationNameModel[]) {
        const fromCities = value.map(city => city.id);

        this.setState({
            fromCities,
            fromCityLocations: value
        });
        this.props.updateDepartureCities(fromCities);
    }
}

const mapStateToProps = ({ newFilterSetting, forms }: ModelState) => {
    return {
        selectedType: newFilterSetting.trailerType
    }
}

export default withStyles(styles)(connect<any, any, any, AddNewFilterSettingFormProps>(mapStateToProps)(AddNewFilterSettingForm));




// WEBPACK FOOTER //
// ./src/account/forms/AddEditFilterSetting.tsx